import { db } from './../../../config/Fire';
import * as Constants from './../../../constants/nodes_database';

export const SET_CITIES = 'SET_CITIES';

const setCities = payload => ({ type: SET_CITIES, payload });

export const setCitiesToState = payload => {
    return dispatch => {
        return db.ref(`${Constants.CITIES}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists() && snapshot.val() !== null) {
                    var cities = {};
                    snapshot.forEach(function(city) {
                        var cityVal = city.val();
                        cities[cityVal.id] = { name: cityVal.name, postalCode: cityVal.postalCode };
                    });
                    dispatch(setCities(cities));
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setCities(null));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setCities(null));
        });
    };
};